import { StarsButton as Button } from '@ps/web-shared-components';
import classNames from 'clsx';
import { isEqual } from 'lodash';
import React from 'react';

import type { SliderHandles, State as SliderState } from '@swf/components/Slider/Slider';
import { Direction } from '@swf/components/Slider/Slider';
import Arrow from '@swf/core/assets/icons/arrow.svg';

import styles from './CasinoSliderButtons.scss';

export interface Props {
  sliderRef: React.RefObject<SliderHandles | null>;
  sliderState: SliderState;
}

const CasinoSliderButtons: React.FC<Props> = ({ sliderRef, sliderState }) => {
  const onDirection = (direction: Direction) => {
    sliderRef.current?.scroll(direction);
  };

  return sliderState.left || sliderState.right ? (
    <>
      <Button
        data-testid="disabled-slider-button-from-new-rapid-streams"
        className={styles.button}
        disabled={!sliderState.left}
        icon={<Arrow />}
        onClick={() => onDirection(Direction.LEFT)}
        size="small"
        variant="casino"
      />
      <Button
        data-testid="enabled-slider-button-from-new-rapid-streams"
        className={classNames(styles.button, styles.right)}
        disabled={!sliderState.right}
        icon={<Arrow />}
        onClick={() => onDirection(Direction.RIGHT)}
        size="small"
        variant="casino"
      />
    </>
  ) : null;
};

export default React.memo(CasinoSliderButtons, isEqual);
